module.exports = __webpack_public_path__ + "static/media/whitelogo.5ecb011c.png";